import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import classnames from 'classnames';

import { translate as t } from '../../../../lib/I18n';
import Smartcard from '../../../../records/customer/Smartcard';
import KeyGoForm from '../../../../records/customer/KeyGoForm';
import { PaymentUnauthorizedError } from '../../../../errors/Payment';
import { ACTError } from '../../../../errors/Smartcard';

import Breadcrumb from '../../Breadcrumb';
import PureRenderComponent from '../../../PureRenderComponent';
import FormWrapper from '../../../form/FormWrapper';

import PaymentError from './Error';
import Success from './Success';
import Form from './Form';
import with3DSecure, { ThreeDSecureType } from '../../../checkout/payment/with3DSecure';
import AuthResponse from '../../../../records/payment/AuthResponse';

class KeyGoRegistration extends PureRenderComponent {
    static propTypes = {
        error: PropTypes.oneOfType([
            PropTypes.instanceOf(PaymentUnauthorizedError),
            PropTypes.instanceOf(ACTError),
        ]),
        paymentSucceeded: PropTypes.bool,
        smartcard: PropTypes.instanceOf(Smartcard).isRequired,
        form: PropTypes.instanceOf(KeyGoForm).isRequired,
        validation: PropTypes.object.isRequired,
        isReplacementPending: PropTypes.bool,
        isSingleStepSmartcardRegistration: PropTypes.bool,
        hasSmartcardInSingleStep: PropTypes.bool,
        formInvalid: PropTypes.bool,
        handleFormChange: PropTypes.func.isRequired,
        handleRetry: PropTypes.func.isRequired,
        enableSameAsDeliveryAddress: PropTypes.bool,
        onChangeUseDeliveryAddress: PropTypes.func,
        submitted: PropTypes.bool,
        renderThreeDSecure: PropTypes.func.isRequired,
        handleRegisterKeyGo: PropTypes.func.isRequired,
        threeDSecureAuthResponse: PropTypes.instanceOf(AuthResponse),
    };

    render() {
        const {
            error,
            paymentSucceeded,
            smartcard,
            form,
            validation,
            hasSmartcardInSingleStep,
            isReplacementPending,
            isSingleStepSmartcardRegistration,
            formInvalid,
            handleFormChange,
            handleRetry,
            enableSameAsDeliveryAddress,
            onChangeUseDeliveryAddress,
            submitted,
            renderThreeDSecure,
            threeDSecureAuthResponse,
            handleRegisterKeyGo,
            user,
        } = this.props;

        return (
            <React.Fragment>
                <Row>
                    {!isSingleStepSmartcardRegistration && (
                        <Breadcrumb pageName={t('account.nav.smartcard.keygoaccount')} />
                    )}
                    <Col
                        md={isSingleStepSmartcardRegistration ? 12 : 10}
                        mdOffset={isSingleStepSmartcardRegistration ? 0 : 1}
                        lg={isSingleStepSmartcardRegistration ? 12 : 10}
                        lgOffset={isSingleStepSmartcardRegistration ? 0 : 1}
                        className={classnames('account', {
                            'margin-bottom': !isSingleStepSmartcardRegistration,
                        })}
                    >
                        {error && <PaymentError error={error} handleRetry={handleRetry} />}
                        {paymentSucceeded && <Success />}
                        {!error && !paymentSucceeded && (
                            <div>
                                <FormWrapper submitted={submitted}>
                                    <Form
                                        smartcard={smartcard}
                                        form={form}
                                        validation={validation}
                                        hasSmartcardInSingleStep={hasSmartcardInSingleStep}
                                        isReplacementPending={isReplacementPending}
                                        isSingleStepSmartcardRegistration={
                                            isSingleStepSmartcardRegistration
                                        }
                                        formInvalid={formInvalid}
                                        handleFormChange={handleFormChange}
                                        enableSameAsDeliveryAddress={enableSameAsDeliveryAddress}
                                        onChangeUseDeliveryAddress={onChangeUseDeliveryAddress}
                                    />
                                </FormWrapper>
                            </div>
                        )}
                    </Col>
                </Row>
                <Row>
                    {threeDSecureAuthResponse && (
                        <Col
                            md={isSingleStepSmartcardRegistration ? 12 : 10}
                            mdOffset={isSingleStepSmartcardRegistration ? 0 : 1}
                            lg={isSingleStepSmartcardRegistration ? 12 : 10}
                            lgOffset={isSingleStepSmartcardRegistration ? 0 : 1}
                            className={'margin-bottom'}
                        >
                            {renderThreeDSecure(threeDSecureAuthResponse, handleRegisterKeyGo, {
                                isKeyGo: true,
                                isKeyGoRegistration: true,
                                isKeyGoUpdate: false,
                                user,
                                threeDSecureAuthResponse
                            })}
                        </Col>
                    )}
                </Row>
            </React.Fragment>
        );
    }
}

export default with3DSecure(ThreeDSecureType.Authorization)(KeyGoRegistration);



// WEBPACK FOOTER //
// ./src/components/account/smartcard/keyGoRegistration/KeyGoRegistration.js